export default __webpack_public_path__ + "static/media/Contact Us.89541398.svg";